import { render, staticRenderFns } from "./TournamentSchedule.vue?vue&type=template&id=52ebb068&scoped=true&"
import script from "./TournamentSchedule.vue?vue&type=script&lang=js&"
export * from "./TournamentSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TournamentSchedule.vue?vue&type=style&index=0&id=52ebb068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebb068",
  null
  
)

export default component.exports